import { ElementWatch, WebRecordingSettings } from '@fullstory/proto/fs/services/orgs';
import { UpdateWatchedElementsRequest } from '@fullstory/proto/fs/api/clientapi';

enum WatchedElements {
  SetWatchedElements = 'watchedElements.setWatchedElements',
  CreateWatchedElement = 'watchedElements.createWatchedElement',
  CreateWatchedElementSuccess = 'watchedElements.createWatchedElement.success',
  CreateWatchedElementFailure = 'watchedElements.createWatchedElement.failure',
  DeleteWatchedElement = 'watchedElements.deleteWatchedElement',
  DeleteWatchedElementSuccess = 'watchedElements.deleteWatchedElement.success',
  DeleteWatchedElementFailure = 'watchedElements.deleteWatchedElement.failure',
  UpdateWatchedElement = 'watchedElements.updateWatchedElement',
  UpdateWatchedElementSuccess = 'watchedElements.updateWatchedElement.success',
  UpdateWatchedElementFailure = 'watchedElements.updateWatchedElement.failure',
  UpdateWatchedElements = 'watchedElements.updateWatchedElements',
  UpdateWatchedElementsSuccess = 'watchedElements.updateWatchedElements.success',
  UpdateWatchedElementsFailure = 'watchedElements.updateWatchedElements.failure',
}

// Hydrated watched elements can have 1-N selectors.
// Ad-hoc watched elements always have 1 while named element backed watched elements can have more.
export type WatchedElement = Omit<ElementWatch, 'selector'> & { selectors: string[] };
export type WatchedElementsReducerState = WatchedElement[];

export type WatchedElementResponse = WebRecordingSettings;
export type WatchedElementRequestBody = UpdateWatchedElementsRequest;

export { WatchedElements };
